import React from "react";
import { format } from "date-fns";

function ClearancePrint({ object }) {
  // Get current date formatted as MMM. DD, YYYY
  const today = format(new Date(), "MMM. dd, yyyy");
  const currentYear = new Date().getFullYear();

  const employee = object?.employee || {};
  const locationObj = object?.location || {};

  const fullName =
    employee.firstName && employee.lastName
      ? `${employee.firstName} ${
          employee.middleName ? employee.middleName + " " : ""
        }${employee.lastName}`
      : "";

  const location = object?.employee?.deployedAt;

  const dueDate = object?.dueDate
    ? format(new Date(object?.dueDate), "MMM. dd")
    : "";

  const position = employee.position || "";
  const startDate = object?.employee?.startDate
    ? format(new Date(object?.employee?.startDate), "MMM. dd, yyyy")
    : "";
  const separationDate = object?.separationDate
    ? format(new Date(object.separationDate), "MMM. dd, yyyy")
    : "";

  const tableRows = [
    { title: "Immediate Supervisor/\nDepartment Head" },
    { title: "Linen / Uniform" },
    { title: "Area Supervisor" },
    { title: "HR / Recruitment Officer In-charge" },
    { title: "Operations Head" },
    { title: "Human Resources Head" },
    { title: "Accouting Head" },
    { title: "General Manager" },
  ];

  const styles = {
    container: {
      fontFamily: `"Times New Roman", sans-serif`,
      width: "100%",
      minHeight: "100vh",
      padding: "2vh 4vw",
      boxSizing: "border-box",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      backgroundColor: "white",
      fontSize: "clamp(10px, 1.2vw, 16px)",
      lineHeight: "1.2",
    },
    pageContent: {
      width: "100%",
      maxWidth: "210mm",
      minHeight: "297mm",
      padding: "15mm",
      boxSizing: "border-box",
      backgroundColor: "white",
      display: "flex",
      flexDirection: "column",
      transform: "scale(1)",
      transformOrigin: "top center",
    },
    header: {
      display: `flex`,
      justifyContent: `center`,
      marginTop: `1rem`,
    },
    title: {
      fontWeight: `700`,
      fontSize: `1.2em`,
      textAlign: "center",
      marginTop: `0.4rem`,
      textDecoration: `underline`,
    },
    label: {
      fontWeight: `500`,
      marginRight: `0.5rem`,
    },
    underline: {
      borderBottom: `1px solid black`,
      padding: `0 0.5rem`,
    },
    cell: {
      border: `1px solid black`,
      padding: `0.5rem`,
      fontSize: "0.9em",
    },
    row: {
      height: `2.5rem`,
    },
  };

  return (
    <>
      <style>
        {`
          @media print {
            body { margin: 0; padding: 0; }
            .clearance-print-container {
              width: 100% !important;
              height: 100vh !important;
              padding: 15mm !important;
              margin: 0 !important;
              font-size: 12px !important;
              page-break-after: avoid;
              transform: none !important;
            }
            .clearance-page-content {
              transform: none !important;
              max-width: none !important;
              width: 100% !important;
              padding: 0 !important;
            }
          }
          @media screen and (max-width: 1200px) {
            .clearance-page-content {
              transform: scale(0.8);
            }
          }
          @media screen and (max-width: 900px) {
            .clearance-page-content {
              transform: scale(0.65);
            }
          }
          @media screen and (max-width: 700px) {
            .clearance-page-content {
              transform: scale(0.5);
            }
          }
        `}
      </style>
      <div className="clearance-print-container" style={styles.container}>
        <div className="clearance-page-content" style={styles.pageContent}>
          {/* Logo */}
          <div
            style={{ display: `flex`, width: `100%`, justifyContent: `center` }}
          >
            <img
              style={{ width: `25%`, marginTop: `2.5rem` }}
              src="/lgstop.png"
              alt="Company Logo"
            />
          </div>

          {/* Header */}
          <div style={styles.header}>
            <div style={{ display: `flex`, flexDirection: `column` }}>
              <p
                style={{ fontWeight: `700`, textAlign: `center`, margin: `0` }}
              >
                LGS Centre, 1639 Dian corner, Rockefeller St. <br /> Brgy. San
                Isidro, Makati City, 1234 Philippines
              </p>
              <p style={{ fontWeight: `700`, textAlign: `center` }}>
                Telephone No: (02) 8889-2680
              </p>
            </div>
          </div>

          {/* Title */}
          <div style={styles.title}>
            <p>EXIT CLEARANCE FORM</p>
          </div>

          {/* Form Content */}
          <div style={{ marginTop: `0rem`, flex: 1 }}>
            {/* Date */}
            <div style={{ display: `flex`, marginBottom: `0.3rem` }}>
              <p style={styles.label}>Date:</p>
              <p style={{ ...styles.underline, width: `19%` }}>{today}</p>
            </div>

            {/* Employee Info */}
            <div style={{ marginBottom: `1rem` }}>
              <p style={{ ...styles.label, marginBottom: `0rem` }}>
                This is to certify that <b>MR./MS.</b>
                <span
                  style={{ ...styles.underline, padding: `0 5rem 0 0.5rem` }}
                >
                  {fullName}
                </span>
                deployed at
                <span
                  style={{ ...styles.underline, padding: `0 8rem 0 0.5rem` }}
                >
                  {location}
                </span>
              </p>
              <p style={{ ...styles.label, marginBottom: `0rem` }}>
                for the position of
                <span
                  style={{ ...styles.underline, padding: `0 8rem 0 0.5rem` }}
                >
                  {position}
                </span>
                has returned all property and equipment belonging
              </p>
              <p style={{ ...styles.label, marginBottom: `0rem` }}>
                to LGS STAFF MANAGEMENT SERVICES INCORPORATED / CLIENT and
                hereby cleared of
              </p>
              <p style={{ ...styles.label, marginBottom: `1.1rem` }}>
                all the dues as of
                <span
                  style={{ ...styles.underline, padding: `0 5rem 0 0.5rem` }}
                >
                  {dueDate}
                </span>
                , 20
                <span
                  style={{ ...styles.underline, padding: `0 1rem 0 0.5rem` }}
                >
                  {currentYear.toString().substring(2)}
                </span>
                .
              </p>
            </div>

            {/* Contract Dates */}
            <div style={{ marginBottom: `1rem` }}>
              <p style={styles.label}>
                Start Date per Contract:
                <span
                  style={{ ...styles.underline, padding: `0 8rem 0 0.5rem` }}
                >
                  {startDate}
                </span>
              </p>
            </div>

            <div style={{ marginBottom: `-0.5rem` }}>
              <p style={styles.label}>
                Date Separated:
                <span
                  style={{ ...styles.underline, padding: `0 8rem 0 0.5rem` }}
                >
                  {separationDate}
                </span>
              </p>
            </div>

            {/* Reason for Separation */}
            <div style={{ marginBottom: `1rem` }}>
              <p style={{ ...styles.label, marginBottom: `-0.5rem` }}>
                Reason of Separation:
                <span style={{ marginLeft: `1rem` }}>☑ Resigned</span>
                <span style={{ marginLeft: `1rem` }}>
                  {object?.resignationType === "Dismissed" ? "☑" : "☐"}{" "}
                  Dismissed
                </span>
                <span style={{ marginLeft: `1rem` }}>
                  {object?.resignationType === "Pull-Out/Re-assignment"
                    ? "☑"
                    : "☐"}{" "}
                  Pull-Out/Re-assignment
                </span>
                <span style={{ marginLeft: `1rem` }}>
                  {object?.resignationType &&
                  !["Resigned", "Dismissed", "Pull-Out/Re-assignment"].includes(
                    ""
                  )
                    ? "☐"
                    : "☐"}{" "}
                  Others:
                </span>
                <span
                  style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}
                >
                  {object?.resignationType &&
                  !["Resigned", "Dismissed", "Pull-Out/Re-assignment"].includes(
                    object.resignationType
                  )
                    ? ""
                    : ""}
                </span>
              </p>
            </div>

            {/* Items Returned */}
            <div style={{ marginBottom: `1.5rem` }}>
              <p style={styles.label}>
                <span style={{ marginRight: `1rem` }}>☐ Company ID</span>
                <span style={{ marginRight: `1rem` }}>☐ Uniform ID</span>
                <span style={{ marginRight: `1rem` }}>☐ Nameplate</span>
                <span style={{ marginRight: `1rem` }}>
                  ☐ Locker / Locker Key
                </span>
                <span style={{ marginRight: `0rem` }}>☐ Others:</span>
                <span
                  style={{ ...styles.underline, padding: `0 3rem 0 0.5rem` }}
                ></span>
              </p>
            </div>

            {/* Table */}
            <table style={{ width: `100%`, borderCollapse: `collapse` }}>
              <thead>
                <tr>
                  <th style={{ ...styles.cell, width: `30%` }}>DEPARTMENT</th>
                  <th style={{ ...styles.cell, width: `30%` }}>REMARKS</th>
                  <th style={{ ...styles.cell, width: `20%` }}>SIGNATURE</th>
                  <th style={{ ...styles.cell, width: `20%` }}>DATE</th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row, index) => (
                  <tr key={index}>
                    <td
                      style={styles.cell}
                      dangerouslySetInnerHTML={{
                        __html: row.title.replace("\n", "<br/>"),
                      }}
                    ></td>
                    <td style={{ ...styles.cell, ...styles.row }}></td>
                    <td style={styles.cell}></td>
                    <td style={styles.cell}></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClearancePrint;
